// extracted by css-extract-rspack-plugin
export default {"icon":"MissingOfficeIcon__icon--sSrdU"};